/* EVCARS shopping assistant widget. Talks to the evcars-assistant Worker (settings.ev_ai_url).
   The chat lives in sessionStorage for the visit; product cards reuse the skin's quick-add form. */
(() => {
  const CFG = window.EV_AI;
  if (!CFG || !CFG.url) return;
  const T = CFG.t;
  const lang = (window.EV_CFG && EV_CFG.lang) === 'ar' ? 'ar' : 'en';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const KEY = 'ev_ai_chat';
  const MAX_SEND = 12;

  const load = () => { try { return JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(chat.slice(-30))); } catch (e) {} };
  let chat = load(); // [{role, content, products?, handoff?}]
  let busy = false;

  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  const icon = (paths) => `<svg class="evx-ico evx-ico-s" viewBox="0 0 24 24" aria-hidden="true" focusable="false">${paths}</svg>`;
  const ICON = {
    spark: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6"/>',
    x: '<path d="M6 6l12 12M18 6 6 18"/>',
    send: '<path d="M4 12h15M13 6l6 6-6 6"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    wa: '<path d="M4 20l1.3-4A8 8 0 1 1 8 18.7z"/><path d="M9 9.5c.3 2 2.5 4.2 4.5 4.5l1-1.2 2 .9c-.2 1.2-1.2 1.8-2.3 1.6C11 14.8 9.2 13 8.7 10.8 8.5 9.7 9.1 8.7 10.3 8.5l.9 2z"/>',
  };
  const money = (n) => (lang === 'ar' ? `${Number(n).toLocaleString('en-US')} درهم` : `AED ${Number(n).toLocaleString('en-US')}`);
  // The model is asked for plain text; strip any markdown that slips through.
  const plain = (s) => String(s || '').replace(/\*\*|__|`/g, '').replace(/^#+\s*/gm, '').trim();

  /* ---------- DOM ---------- */
  const fab = el('button', 'evx-ai-fab');
  fab.type = 'button';
  fab.setAttribute('aria-haspopup', 'dialog');
  fab.innerHTML = `${icon(ICON.spark)}<span class="evx-ai-fab-l" aria-hidden="true">${T.fab}</span>`;
  fab.setAttribute('aria-label', T.fab);
  // Phones: the label shows on arrival, then the button shrinks to a circle once the visitor scrolls, so it
  // stops covering the content under it (same size as the WhatsApp bubble on the other side).
  const mini = () => fab.classList.toggle('evx-ai-mini', window.scrollY > 160);
  window.addEventListener('scroll', mini, { passive: true });
  mini();

  const sheet = el('div', 'evx-ai');
  sheet.hidden = true;
  sheet.innerHTML = `
    <div class="evx-ai-bg" data-ai-close></div>
    <section class="evx-ai-panel" role="dialog" aria-modal="true" aria-labelledby="evx-ai-t">
      <header class="evx-ai-head">
        <div><h3 id="evx-ai-t">${T.title}</h3><p>${T.sub}</p></div>
        <button type="button" class="evx-ai-new" data-ai-new>${T.newChat}</button>
        <button type="button" class="evx-ai-x" data-ai-close aria-label="${T.close}">${icon(ICON.x)}</button>
      </header>
      <div class="evx-ai-log" aria-live="polite"></div>
      <form class="evx-ai-form">
        <label class="evx-vh" for="evx-ai-in">${T.ph}</label>
        <textarea id="evx-ai-in" rows="1" maxlength="1000" placeholder="${T.ph}" enterkeyhint="send"></textarea>
        <button type="submit" class="evx-ai-send" aria-label="${T.send}">${icon(ICON.send)}</button>
      </form>
      <p class="evx-ai-note">${T.note}</p>
    </section>`;
  document.body.append(fab, sheet);
  const log = sheet.querySelector('.evx-ai-log');
  const form = sheet.querySelector('.evx-ai-form');
  const input = sheet.querySelector('textarea');

  function card(p) {
    const a = el('article', 'evx-ai-card');
    const img = p.img ? `<img src="${p.img}" alt="" loading="lazy" width="72" height="72">` : '';
    a.innerHTML = `<a class="evx-ai-card-img" href="${p.url}">${img}</a><div class="evx-ai-card-b"><a class="evx-ai-card-t" href="${p.url}"></a><p class="evx-ai-card-fit"></p><div class="evx-ai-card-row"><b>${money(p.price)}</b>${p.compare && p.compare > p.price ? `<s>${money(p.compare)}</s>` : ''}</div></div>`;
    a.querySelector('.evx-ai-card-t').textContent = p.variant ? `${p.title} · ${p.variant}` : p.title;
    a.querySelector('.evx-ai-card-fit').textContent = p.fits ? `${T.fits} ${p.fits}` : '';
    const f = el('form', 'evx-ai-card-add');
    f.action = root + 'cart/add';
    f.method = 'post';
    f.setAttribute('data-evx-add', '');
    f.innerHTML = `<input type="hidden" name="id" value="${p.variant_id}"><input type="hidden" name="quantity" value="1"><button type="submit" class="evx-card-add"${p.available && p.variant_id ? '' : ' disabled'}>${p.available ? `${icon(ICON.plus)} ${T.add}` : T.soldOut}</button>`;
    a.querySelector('.evx-ai-card-b').append(f);
    return a;
  }

  function bubble(m) {
    const wrap = el('div', `evx-ai-msg evx-ai-${m.role === 'user' ? 'me' : 'bot'}`);
    wrap.append(el('p', 'evx-ai-bubble', m.role === 'user' ? m.content : plain(m.content)));
    if (m.products && m.products.length) {
      const list = el('div', 'evx-ai-cards');
      m.products.forEach((p) => list.append(card(p)));
      wrap.append(list);
    }
    if (m.handoff && m.handoff.phone) {
      const wa = el('a', 'evx-btn evx-btn-lime evx-ai-wa');
      wa.href = `https://wa.me/${m.handoff.phone}${m.handoff.text ? `?text=${encodeURIComponent(m.handoff.text)}` : ''}`;
      wa.target = '_blank';
      wa.rel = 'noopener';
      wa.innerHTML = `${icon(ICON.wa)}<span>${T.wa}</span>`;
      wrap.append(wa);
    }
    return wrap;
  }

  function render() {
    log.textContent = '';
    log.append(bubble({ role: 'assistant', content: T.hello }));
    if (!chat.length) {
      const qs = el('div', 'evx-ai-qs');
      [T.q1, T.q2, T.q3].forEach((q) => {
        const b = el('button', 'evx-ai-q', q);
        b.type = 'button';
        b.addEventListener('click', () => send(q));
        qs.append(b);
      });
      log.append(qs);
    }
    chat.forEach((m) => log.append(bubble(m)));
    if (busy) log.append(el('p', 'evx-ai-typing', T.typing));
    // A new answer opens at its first line (cards can be long); otherwise stay at the bottom.
    const lastMsg = log.lastElementChild;
    log.scrollTop = !busy && chat.length && chat[chat.length - 1].role === 'assistant' && lastMsg ? lastMsg.offsetTop - 12 : log.scrollHeight;
  }

  /* ---------- Open / close ---------- */
  let lastFocus = null;
  // iOS keeps the layout viewport when the keyboard opens: size the full-screen panel to what is actually visible.
  const panel = sheet.querySelector('.evx-ai-panel');
  const vv = window.visualViewport;
  const phone = window.matchMedia('(max-width: 767px)');
  function fit(keyboard) {
    if (!vv || !phone.matches || sheet.hidden) { panel.style.height = ''; panel.style.top = ''; return; }
    panel.style.height = vv.height + 'px';
    panel.style.top = vv.offsetTop + 'px';
    if (keyboard === true && document.activeElement === input) log.scrollTop = log.scrollHeight; // keep the latest line above the keyboard
  }
  if (vv) { vv.addEventListener('resize', () => fit(true)); vv.addEventListener('scroll', () => fit(false)); }
  function open() {
    lastFocus = document.activeElement;
    render();
    sheet.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('evx-ai-open');
    requestAnimationFrame(() => sheet.classList.add('evx-ai-on'));
    fit();
    setTimeout(() => input.focus(), 60);
  }
  function close() {
    sheet.classList.remove('evx-ai-on');
    sheet.hidden = true;
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('evx-ai-open');
    if (lastFocus) lastFocus.focus();
  }
  fab.addEventListener('click', open);
  sheet.addEventListener('click', (e) => {
    if (e.target.closest('[data-ai-close]')) close();
    if (e.target.closest('[data-ai-new]')) { chat = []; save(); render(); input.focus(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !sheet.hidden) close(); });

  /* ---------- Send ---------- */
  function context() {
    const car = window.EV && EV.get ? EV.get() : null;
    const country = window.EV && EV.country ? EV.country() : null;
    const m = location.pathname.match(/\/products\/([^/?#]+)/);
    return { lang, vehicle: car && !car.universal ? car.handle : '', country: country && /^[A-Z]{2}$/i.test(country) ? country.toUpperCase() : '', product: m ? decodeURIComponent(m[1]) : '' };
  }

  async function send(text) {
    text = String(text || '').trim();
    if (!text || busy) return;
    chat.push({ role: 'user', content: text });
    busy = true;
    save();
    render();
    // The Worker only needs the words: earlier cards are summarised so the model knows what it showed.
    const messages = chat.slice(-MAX_SEND).map((m) => ({ role: m.role, content: m.products && m.products.length ? `${m.content}\n[cards shown: ${m.products.map((p) => p.handle).join(', ')}]` : m.content }));
    try {
      const r = await fetch(CFG.url.replace(/\/$/, '') + '/chat', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ messages, context: context() }) });
      if (r.status === 429) throw new Error(T.slow);
      if (!r.ok) throw new Error(T.err);
      const d = await r.json();
      chat.push({ role: 'assistant', content: d.reply || T.err, products: d.products || [], handoff: d.handoff || null });
    } catch (e) {
      chat.pop(); // keep the history valid (user/assistant turns alternate); the text goes back in the box
      input.value = text;
      busy = false;
      render();
      log.append(bubble({ role: 'assistant', content: e.message || T.err, handoff: { phone: CFG.wa } }));
      log.scrollTop = log.scrollHeight;
      return;
    }
    busy = false;
    save();
    render();
  }

  form.addEventListener('submit', (e) => { e.preventDefault(); const v = input.value; input.value = ''; autosize(); send(v); });
  input.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); form.requestSubmit(); } });
  const autosize = () => { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight, 120) + 'px'; };
  input.addEventListener('input', autosize);
})();
